import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Tile, Button } from "../partials";
import { favouritesService } from '~/js/_services';

let vehicles = window.vehicle_data ?? null;

class SharedFavourites extends Component {
    
    state = {
        favourites: null
    };

    componentDidMount() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const ids = urlParams.getAll('v');

        // Put ids in favourites in state
        this.setState({
            favourites: ids,
        })
    };
    
    renderItem = (item, i) => {
        // console.log(`VehiclesFavourited render item ${i}`, item['@LISTING_SEQ']);
        return (
            <div className="vehicles-favourited__item" key={i}>
                <Tile {...item} />
            </div>
        );
    };

    render() {
        const { favourites } = this.state;
        if (favourites === null) return null;

        const items = [];
        favourites.forEach(fav => {
            const index = vehicles.findIndex(v => parseInt(v['@LISTING_SEQ']) === parseInt(fav));
            if (index !== -1) {
                items.push(vehicles[index]);
            }
        });

        if (items.length > 0) {
            return (
                <div className="vehicles-favourited">
                    <div className="vehicles-favourited__wrap"> 
                        <div className="vehicles-favourited__head"> 
                            <h3 className="vehicles-favourited__h">
                                Shared Favourites
                            </h3>
                        </div>
                        <div className="vehicles-favourited__list"> 
                            { items.map(this.renderItem) }
                        </div>
                    </div>
                </div>
            );
        } else {

            return (
                <div className="notice">
                    <div className="notice__wrap">

                        <div className="notice__body">
                            <h3 className="notice__title">Looks like there's nothing here anymore.</h3>
                            <div className="notice__text">Not to worry, we have a huge range of fantastic vehicles for you to find your new favourite. Have a look at our used vehicle range or get in touch to talk with us about a new vehicle.</div>
                            <div className="notice__cta">
                                <Button 
                                    title={`New Vehicles`}
                                    href="/"
                                    modifiers={['solid', 'black']} 
                                    chevron={true}
                                />
                                <Button 
                                    title={`Used Vehicles`}
                                    href="/"
                                    modifiers={['outline', 'black']} 
                                    chevron={true}
                                />
                            </div>
                            
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default function (el, props) {
    ReactDOM.render(<SharedFavourites {...props} />, el)
}
